import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import ActionBar from '../../layout/ActionBar';
import SelectSubcontractor from './selectSubcontractor';
import SelectProject from './selectProject';
import RequestDetails from './requestDetails';
import SelectRequest from './selectRequest';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const RequestCreateView = props => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ActionBar, {
      showBackButton: true,
      children: /*#__PURE__*/_jsx("h1", {
        "data-id": "request-step",
        className: "m-4 ml-6",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "request.create.title"
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SelectProject, {
          onSelectProject: props.onSelectProject,
          projectId: props.projectId,
          project: props.project,
          isOpen: props.currentStep === 0
        }), props.showSelectRequestStep && props.project && /*#__PURE__*/_jsx(SelectRequest, {
          onSelectRequest: props.onSelectRequest,
          project: props.project,
          request: props.request,
          isOpen: props.currentStep === 1
        }), /*#__PURE__*/_jsx(SelectSubcontractor, {
          project: props.project,
          subcontractorOrga: props.subcontractor,
          subcontractorUser: props.subcontractorUser,
          isOpen: props.currentStep === 2,
          onSelectOrganisation: props.onSelectSubcontractor,
          onSelectUser: props.onSelectSubcontractorUser
        }), /*#__PURE__*/_jsx(RequestDetails, {
          onSubmit: props.onSubmitDetails,
          isOpen: props.currentStep === 3,
          loading: props.loading
        })]
      })
    })]
  });
};
RequestCreateView.propTypes = {
  onSelectSubcontractor: PropTypes.func.isRequired,
  onSelectSubcontractorUser: PropTypes.func.isRequired,
  onSelectRequest: PropTypes.func.isRequired,
  onSelectProject: PropTypes.func.isRequired,
  showSelectRequestStep: PropTypes.bool.isRequired,
  onSubmitDetails: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  projectId: PropTypes.number,
  project: PropTypes.object,
  request: PropTypes.object,
  subcontractor: PropTypes.object,
  subcontractorUser: PropTypes.object,
  loading: PropTypes.bool.isRequired
};
export default RequestCreateView;